/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Pale_Heron_SoarInputs */

const en_keen_pale_heron_soar = /** @type {(inputs: Keen_Pale_Heron_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select which segments are used to break down value results.`)
};

const de_keen_pale_heron_soar = /** @type {(inputs: Keen_Pale_Heron_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie Segmente aus, um Wertergebnisse aufzuschlüsseln.`)
};

/**
* | output |
* | --- |
* | "Select which segments are used to break down value results." |
*
* @param {Keen_Pale_Heron_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_pale_heron_soar = /** @type {((inputs?: Keen_Pale_Heron_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Pale_Heron_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_pale_heron_soar(inputs)
	return de_keen_pale_heron_soar(inputs)
});